import React, { useState, useEffect } from "react";
import { Descriptions, Image, message } from "antd";
import { useLocation } from "react-router-dom";
import { binaryContentsHooks as cHooks } from "../hooks";
const StoryEditPage = () => {
  const [groupList, setGroupList] = useState([]);
  const [authorList, setAuthorList] = useState([]);
  const location = useLocation();
  const { contentData } = location.state || {};

  const fetchGroups = async () => {
    try {
      const res = await cHooks.contentsGroupList();
      if (res.data) setGroupList(res.data.data);
    } catch {
      message.error("그룹 리스트 불러오기 실패!");
    }
  };

  const authorGroups = async () => {
    try {
      const res = await cHooks.contentsAuthorList();
      if (res.data) setAuthorList(res.data.data);
    } catch {
      message.error("작성자 리스트 불러오기 실패!");
    }
  };

  useEffect(() => {
    fetchGroups();
    authorGroups();
  }, []);

  const decodeMarkdown = (text) => {
    try {
      return decodeURIComponent(escape(atob(text)));
    } catch {
      return text || "";
    }
  };

  return (
    <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "20px" }}>
      <h2>콘텐츠 상세 보기</h2>
      <Descriptions column={1} bordered>
        <Descriptions.Item label="제목">
          {contentData?.story_title || "-"}
        </Descriptions.Item>

        <Descriptions.Item label="썸네일">
          {contentData?.story_thumbimg ? (
            <Image width={150} src={contentData.story_thumbimg} />
          ) : (
            "-"
          )}
        </Descriptions.Item>

        <Descriptions.Item label="백그라운드 이미지">
          {contentData?.story_bgimg ? (
            <Image width={150} src={contentData.story_bgimg} />
          ) : (
            "-"
          )}
        </Descriptions.Item>

        <Descriptions.Item label="내용">
          <div
            style={{
              padding: "10px",
              border: "1px solid #eee",
              whiteSpace: "pre-wrap",
              background: "#fafafa",
              borderRadius: "4px",
              minHeight: "200px",
            }}
            dangerouslySetInnerHTML={{
              __html: decodeMarkdown(contentData?.story_content),
            }}
          />
        </Descriptions.Item>

        <Descriptions.Item label="노출 여부">
          {contentData?.exposure ? "노출" : "비노출"}
        </Descriptions.Item>

        <Descriptions.Item label="가격">
          {contentData?.story_price || 0} 포인트
        </Descriptions.Item>

        <Descriptions.Item label="작성일">
          {contentData?.cont_date
            ? new Date(contentData.cont_date).toLocaleString()
            : "-"}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default StoryEditPage;
